/* eslint-disable react/prop-types */
import React from 'react';

export function DivRelative({ className = '', children, height, opacity, transform }) {
  return (
    <div className={`div-relative ${className}`} style={{ height, opacity, transform }}>
      {children}
    </div>
  );
}
